<script setup>
import { ref, defineProps, watch, defineEmits, computed } from 'vue'

const emit = defineEmits(["close"])

const props = defineProps({
    show: Boolean,
    message: String,
    Error: Boolean
})

const hidden = computed(() => props.show)

watch(hidden, (toShow, oldShow) => {
    if (toShow != oldShow) {
        hidden.value = toShow
    }
})

function status(Error) {
    if (Error == true) {
        return "Ops"
    }
    return "OK"
}
function close() {
    hidden.value = false
    emit('close', { show: false })
}

</script>

<template>
    <div id="toast-default" v-show="hidden"
        class="toast flex items-center w-full max-w-xs p-4 text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800"
        role="alert">
        <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-blue-500 bg-blue-100 rounded-lg  dark:text-blue-200"
            :class="[Error ? 'dark:bg-red-800' : 'dark:bg-blue-800']">
            {{ status(Error) }}
        </div>
        <div class="ml-3 text-sm font-normal">{{ message }}</div>
        <button @click="close()" type="button"
            class="ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700"
            data-dismiss-target="#toast-default" aria-label="Close">
            <span class="sr-only">Close</span>
            <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"></path>
            </svg>
        </button>
    </div>
</template>

<style scoped>.toast {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 10px;
}</style>